/* Nokbox vs CLEAR Kit comparison page — analytics + small behaviors.
   Events fire to gtag and dataLayer when present; the page works fully without them. */
(function () {
  'use strict';
  if (window.__biwcmpInit) return; // sections may each load this file; bind once
  window.__biwcmpInit = true;

  function track(name, params) {
    var payload = params || {};
    var path = window.location.pathname;
    payload.page_surface = path === '/' ? 'shop_home' : path.split('/').filter(Boolean).pop() || 'shop';
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* analytics must never break the page */ }
  }

  // Click events: any element carrying data-cmp-event
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-cmp-event]') : null;
    if (!el) return;
    track(el.getAttribute('data-cmp-event'), {
      link_text: (el.textContent || '').trim().slice(0, 80),
      link_url: el.getAttribute('href') || ''
    });
  });

  // Comparison table viewed (once)
  var table = document.querySelector('[data-cmp-table]');
  if (table && 'IntersectionObserver' in window) {
    var seen = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen) {
          seen = true;
          track('comparison_table_view');
          io.disconnect();
        }
      });
    }, { threshold: 0.2 });
    io.observe(table);
  }

  // Buy cards: variant selection without leaving the comparison page.
  // The displayed price always tracks the selected variant, so the card can never
  // advertise a price the cart will not honour.
  function money(cents, template) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (template || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  document.querySelectorAll('[data-cmp-buy]').forEach(function (form) {
    var raw = form.querySelector('[data-cmp-variants]');
    var idField = form.querySelector('[data-cmp-varid]');
    var button = form.querySelector('[data-cmp-buybtn]');
    var card = form.closest('.biwcmp-prod-card');
    var priceEl = card && card.querySelector('[data-cmp-price]');
    if (!raw || !idField) return;

    var variants;
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var selects = form.querySelectorAll('[data-cmp-opt]');
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var defaultLabel = button ? button.textContent.trim() : 'Add to cart';

    function sync() {
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-cmp-opt'), 10)] = s.value; });

      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];

      if (!match) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }

      idField.value = match.id;

      if (priceEl) {
        var html = money(match.price, fmt);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += ' <s style="color:var(--cmp-muted);font-weight:400;">' + money(match.compare_at_price, fmt) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? defaultLabel : 'Sold out';
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();
  });

  // FAQ expansion
  document.querySelectorAll('[data-cmp-faq] details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        var q = d.querySelector('summary');
        track('comparison_faq_expand', { faq_question: q ? q.textContent.trim().slice(0, 100) : '' });
      }
    });
  });
})();
